/*
  CMX mini cart (DAR Media) - adaptacion Yuvens / Shrine.
  - Se abre al dar clic en el carrito o despues de que el tema agrega un producto (no reemplaza el form del tema).
  - Barra de recompensas por niveles, upsells complementarios, codigo de descuento y precios tachados.
  - Sin datos inventados: todo sale del carrito real (/cart.js) y del catalogo.
*/
(function () {
  'use strict';

  var configEl = document.getElementById('cmx-config');
  var drawer = document.getElementById('cmx-drawer');
  var overlay = document.getElementById('cmx-overlay');
  if (!configEl || !drawer || !overlay) return;

  var config = JSON.parse(configEl.textContent);
  var tiers = config.tiers
    .filter(function (tier) { return tier.enabled && tier.amount > 0; })
    .sort(function (a, b) { return a.amount - b.amount; });
  var giftKeys = tiers.map(function (tier) { return tier.key; });

  var el = {
    count: document.getElementById('cmx-count'),
    rewards: document.getElementById('cmx-rewards'),
    rewardsMessage: document.getElementById('cmx-rewards-message'),
    rewardsFill: document.getElementById('cmx-rewards-fill'),
    rewardsMarks: document.getElementById('cmx-rewards-marks'),
    upsells: document.getElementById('cmx-upsells'),
    upsellsTrack: document.getElementById('cmx-upsells-track'),
    items: document.getElementById('cmx-items'),
    empty: document.getElementById('cmx-empty'),
    footer: document.getElementById('cmx-footer'),
    subtotal: document.getElementById('cmx-subtotal'),
    discountRow: document.getElementById('cmx-discount-row'),
    discountTotal: document.getElementById('cmx-discount-total'),
    checkout: document.getElementById('cmx-checkout'),
    checkoutTotal: document.getElementById('cmx-checkout-total'),
    discountForm: document.getElementById('cmx-discount-form'),
    discountInput: document.getElementById('cmx-discount-input'),
    discountMsg: document.getElementById('cmx-discount-msg'),
    discountCodes: document.getElementById('cmx-discount-codes')
  };

  var state = { cart: null, lastOpen: 0, lastFocus: null, upsellFor: '', pendingCode: '' };
  var productCache = {};
  var nativeFetch = window.fetch.bind(window);

  /* ---------- utilidades ---------- */
  function formatMoney(cents) {
    var value = (cents || 0) / 100;
    var format = config.moneyFormat || '${{amount}}';
    function withDelimiters(number, decimals, thousands, decimal) {
      var parts = number.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }

  function shortTitle(title) {
    return String(title || '').split(' - ')[0].split(' (')[0].trim();
  }

  function imageUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function request(url, options) {
    var opts = Object.assign({ credentials: 'same-origin', headers: {} }, options || {});
    opts.headers = Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json', 'X-CMX': '1' }, opts.headers);
    return nativeFetch(url, opts).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  /* ---------- abrir / cerrar ---------- */
  function show() {
    if (drawer.classList.contains('is-open')) return;
    state.lastFocus = document.activeElement;
    overlay.hidden = false;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
    });
    document.body.classList.add('overflow-hidden');
    setTimeout(function () { drawer.focus(); }, 60);
  }

  function hide() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    setTimeout(function () {
      if (!drawer.classList.contains('is-open')) {
        overlay.hidden = true;
        drawer.hidden = true;
      }
    }, 380);
    if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus();
  }

  function open() {
    var now = Date.now();
    if (now - state.lastOpen < 500) return;
    state.lastOpen = now;
    refresh().then(show, show);
  }

  /* ---------- datos del carrito ---------- */
  function refresh() {
    return request(config.routes.cartJs)
      .then(syncGifts)
      .then(function (cart) {
        return loadProducts(cart).then(function () { return cart; });
      })
      .then(function (cart) {
        state.cart = cart;
        render(cart);
        updateBubble();
        return cart;
      });
  }

  function isGift(item) {
    return item.properties && item.properties._cmx_gift && giftKeys.indexOf(item.properties._cmx_gift) > -1;
  }

  // Monto para los niveles: productos con sus descuentos por producto, sin los descuentos de pedido
  // (los regalos se cubren con un descuento de pedido; si se restara, el regalo se quitaria solo).
  function baseTotal(cart) {
    var total = cart.items_subtotal_price;
    cart.items.forEach(function (item) { if (isGift(item)) total -= item.final_line_price; });
    return Math.max(0, total);
  }

  // El regalo esta cubierto si su linea quedo en $0 o si Shopify aplico un descuento de pedido "Regalo ..."
  function giftCovered(cart, item) {
    if (item.final_line_price === 0) return true;
    return (cart.cart_level_discount_applications || []).some(function (d) { return /regalo/i.test(d.title || ''); });
  }

  // Regalos por nivel: solo si se activo "agregar automaticamente" (requiere un descuento real en Shopify que lo deje en $0).
  function syncGifts(cart) {
    var ops = [];
    var base = baseTotal(cart);
    tiers.forEach(function (tier) {
      if (!tier.autoAdd || !tier.giftVariantId) return;
      var line = cart.items.filter(function (item) { return item.properties && item.properties._cmx_gift === tier.key; })[0];
      if (base >= tier.amount && !line) ops.push({ add: tier });
      if (base < tier.amount && line) ops.push({ remove: line });
    });
    if (!ops.length) return Promise.resolve(cart);
    return ops
      .reduce(function (chain, op) {
        return chain.then(function () {
          if (op.add) {
            return request(config.routes.add, {
              method: 'POST',
              body: JSON.stringify({ items: [{ id: op.add.giftVariantId, quantity: 1, properties: { _cmx_gift: op.add.key } }] })
            });
          }
          return request(config.routes.change, { method: 'POST', body: JSON.stringify({ id: op.remove.key, quantity: 0 }) });
        });
      }, Promise.resolve())
      .then(function () { return request(config.routes.cartJs); })
      .catch(function () { return cart; });
  }

  // Precio "antes" (compare at) por variante; se guarda en memoria para no repetir peticiones.
  function loadProducts(cart) {
    var handles = [];
    cart.items.forEach(function (item) {
      if (item.handle && !productCache[item.handle] && handles.indexOf(item.handle) === -1) handles.push(item.handle);
    });
    return Promise.all(
      handles.map(function (handle) {
        return nativeFetch(config.routes.root + 'products/' + handle + '.js', { credentials: 'same-origin' })
          .then(function (response) { return response.ok ? response.json() : null; })
          .then(function (product) { productCache[handle] = product || {}; })
          .catch(function () { productCache[handle] = {}; });
      })
    );
  }

  function compareAt(item) {
    var product = productCache[item.handle];
    if (!product || !product.variants) return 0;
    var variant = product.variants.filter(function (v) { return v.id === item.variant_id; })[0];
    return variant && variant.compare_at_price ? variant.compare_at_price : 0;
  }

  /* ---------- render ---------- */
  function render(cart) {
    el.count.textContent = cart.item_count;
    renderRewards(cart);

    if (!cart.item_count) {
      el.items.innerHTML = '';
      el.footer.hidden = true;
      el.empty.hidden = false;
      el.upsells.hidden = true;
      if (!config.showRewardsOnEmpty) el.rewards.hidden = true;
      return;
    }

    el.empty.hidden = true;
    el.footer.hidden = false;
    renderItems(cart);
    renderTotals(cart);
    renderCodes(cart);
    loadUpsells(cart);
  }

  function renderRewards(cart) {
    if (!tiers.length) { el.rewards.hidden = true; return; }
    var base = baseTotal(cart);
    var max = tiers[tiers.length - 1].amount;
    var next = tiers.filter(function (tier) { return base < tier.amount; })[0];

    if (next) {
      el.rewardsMessage.innerHTML = escapeHtml(next.message).replace('[amount]', '<strong>' + escapeHtml(formatMoney(next.amount - base)) + '</strong>');
    } else {
      el.rewardsMessage.textContent = tiers[tiers.length - 1].done;
    }
    el.rewardsFill.style.width = Math.min(100, (base / max) * 100) + '%';

    el.rewardsMarks.innerHTML = tiers
      .map(function (tier) {
        var reached = base >= tier.amount;
        var position = Math.min(100, (tier.amount / max) * 100);
        var icon = tier.icon === 'truck'
          ? '<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.5"/><circle cx="17" cy="18" r="1.5"/>'
          : '<path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 21V7"/><path d="M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"/>';
        return (
          '<span class="cmx-rewards__mark' + (reached ? ' is-reached' : '') + '" style="left:' + position + '%">' +
          '<span class="cmx-rewards__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + icon + '</svg></span>' +
          '<span class="cmx-rewards__label">' + escapeHtml(tier.label) + '</span></span>'
        );
      })
      .join('');
    el.rewards.hidden = false;
  }

  function renderItems(cart) {
    el.items.innerHTML = cart.items
      .map(function (item) {
        var gift = isGift(item);
        var free = gift && giftCovered(cart, item);
        var was = compareAt(item) * item.quantity;
        if (item.original_line_price > was) was = item.original_line_price;
        var showWas = free ? item.original_line_price > 0 : was > item.final_line_price;
        if (free) was = item.original_line_price;
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<span class="cmx-item__variant">' + escapeHtml(item.variant_title) + '</span>' : '';
        var props = '';
        if (item.properties) {
          Object.keys(item.properties).forEach(function (key) {
            var value = item.properties[key];
            if (key.charAt(0) === '_' || !value) return;
            props += '<span>' + escapeHtml(key) + ': ' + escapeHtml(value) + '</span>';
          });
        }
        var image = item.image
          ? '<img class="cmx-item__img" src="' + imageUrl(item.image, 180) + '" alt="' + escapeHtml(item.product_title) + '" width="80" height="80" loading="lazy">'
          : '<span class="cmx-item__img"></span>';
        var qty = gift
          ? '<span class="cmx-item__gift">' + escapeHtml(config.texts.gift) + '</span>'
          : '<div class="cmx-qty">' +
            '<button type="button" class="cmx-qty__btn" data-cmx-action="minus" data-key="' + item.key + '" aria-label="-">&minus;</button>' +
            '<span class="cmx-qty__val">' + item.quantity + '</span>' +
            '<button type="button" class="cmx-qty__btn" data-cmx-action="plus" data-key="' + item.key + '" aria-label="+">+</button></div>';

        return (
          '<div class="cmx-item' + (gift ? ' cmx-item--gift' : '') + '" data-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="cmx-item__media">' + image + '</a>' +
          '<div class="cmx-item__info">' +
          '<a href="' + item.url + '" class="cmx-item__title">' + escapeHtml(shortTitle(item.product_title)) + '</a>' +
          variant + (props ? '<span class="cmx-item__props">' + props + '</span>' : '') +
          '<div class="cmx-item__bottom">' + qty +
          '<div class="cmx-item__prices">' +
          (showWas ? '<s class="cmx-item__was">' + formatMoney(was) + '</s>' : '') +
          '<span class="cmx-item__price">' + (free ? escapeHtml(config.texts.free || 'Gratis') : formatMoney(item.final_line_price)) + '</span>' +
          (showWas && !gift ? '<span class="cmx-item__save">' + escapeHtml(config.texts.savings) + ' ' + formatMoney(was - item.final_line_price) + '</span>' : '') +
          '</div></div>' +
          (gift ? '' : '<button type="button" class="cmx-item__remove" data-cmx-action="remove" data-key="' + item.key + '">' + escapeHtml(config.texts.remove) + '</button>') +
          '</div></div>'
        );
      })
      .join('');
  }

  function renderTotals(cart) {
    // Subtotal ya trae los descuentos por producto; la fila de descuento solo muestra los de pedido (regalos, codigos)
    var orderDiscount = cart.items_subtotal_price - cart.total_price;
    el.subtotal.textContent = formatMoney(cart.items_subtotal_price);
    if (orderDiscount > 0) {
      el.discountRow.hidden = false;
      el.discountTotal.textContent = '-' + formatMoney(orderDiscount);
    } else {
      el.discountRow.hidden = true;
    }
    el.checkoutTotal.textContent = formatMoney(cart.total_price);
    var href = config.routes.checkout;
    if (state.pendingCode) href += '?discount=' + encodeURIComponent(state.pendingCode);
    el.checkout.setAttribute('href', href);
  }

  function renderCodes(cart) {
    if (!el.discountCodes) return;
    var codes = (cart.discount_codes || []).filter(function (code) { return code.applicable; });
    var chips = codes.map(function (code) {
      return '<span class="cmx-code">' + escapeHtml(code.code) +
        '<button type="button" data-cmx-action="remove-code" data-code="' + escapeHtml(code.code) + '" aria-label="Quitar">&times;</button></span>';
    });
    if (state.pendingCode && !codes.length) {
      chips.push('<span class="cmx-code">' + escapeHtml(state.pendingCode) + ' &middot; ' + escapeHtml(config.discount.atCheckout) + '</span>');
    }
    el.discountCodes.innerHTML = chips.join('');
  }

  /* ---------- upsells (recomendaciones complementarias de Shopify) ---------- */
  function loadUpsells(cart) {
    if (!config.upsells.enabled) return;
    var regular = cart.items.filter(function (item) { return !isGift(item); });
    if (!regular.length) { el.upsells.hidden = true; return; }
    var inCart = cart.items.map(function (item) { return item.product_id; });
    var source = regular[0].product_id;
    var key = source + ':' + inCart.join(',');
    if (state.upsellFor === key) return;
    state.upsellFor = key;

    function fetchIntent(intent) {
      return nativeFetch(config.routes.recommendations + '?product_id=' + source + '&limit=10&intent=' + intent, { credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.json() : { products: [] }; })
        .then(function (data) { return data.products || []; })
        .catch(function () { return []; });
    }

    fetchIntent('complementary')
      .then(function (products) {
        var usable = products.filter(function (p) { return p.available && inCart.indexOf(p.id) === -1; });
        return usable.length ? usable : fetchIntent('related');
      })
      .then(function (products) {
        var list = products
          .filter(function (p) { return p.available && inCart.indexOf(p.id) === -1; })
          .slice(0, config.upsells.max);
        if (!list.length) { el.upsells.hidden = true; return; }
        el.upsellsTrack.innerHTML = list
          .map(function (p) {
            var variant = (p.variants || []).filter(function (v) { return v.available; })[0];
            if (!variant) return '';
            var image = p.featured_image ? imageUrl(p.featured_image, 240) : '';
            var was = variant.compare_at_price > variant.price ? '<s>' + formatMoney(variant.compare_at_price) + '</s>' : '';
            return (
              '<div class="cmx-upsell">' +
              '<a href="' + p.url + '" class="cmx-upsell__media">' + (image ? '<img src="' + image + '" alt="' + escapeHtml(p.title) + '" width="72" height="72" loading="lazy">' : '') + '</a>' +
              '<div class="cmx-upsell__info"><a href="' + p.url + '" class="cmx-upsell__title">' + escapeHtml(shortTitle(p.title)) + '</a>' +
              '<span class="cmx-upsell__price">' + was + formatMoney(variant.price) + '</span></div>' +
              '<button type="button" class="cmx-upsell__add" data-cmx-action="add" data-variant="' + variant.id + '">' + escapeHtml(config.upsells.addLabel) + '</button>' +
              '</div>'
            );
          })
          .join('');
        el.upsells.hidden = false;
      });
  }

  /* ---------- acciones ---------- */
  function changeLine(key, quantity) {
    var line = el.items.querySelector('[data-key="' + key + '"]');
    if (line) line.classList.add('is-updating');
    return request(config.routes.change, { method: 'POST', body: JSON.stringify({ id: key, quantity: quantity }) })
      .then(refresh)
      .catch(function () { if (line) line.classList.remove('is-updating'); });
  }

  function addVariant(variantId, button) {
    if (button) button.classList.add('is-loading');
    return request(config.routes.add, { method: 'POST', body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) })
      .then(function () { state.upsellFor = ''; return refresh(); })
      .catch(function (error) {
        if (button) button.classList.remove('is-loading');
        if (error && error.description) window.alert(error.description);
      });
  }

  function applyCodes(codes) {
    return request(config.routes.update, { method: 'POST', body: JSON.stringify({ discount: codes.join(',') }) });
  }

  function showDiscountMessage(text, isError) {
    if (!el.discountMsg) return;
    el.discountMsg.textContent = text;
    el.discountMsg.classList.toggle('is-error', !!isError);
    el.discountMsg.hidden = !text;
  }

  if (el.discountForm) {
    el.discountForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var code = el.discountInput.value.trim();
      if (!code) return;
      var current = ((state.cart && state.cart.discount_codes) || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
      applyCodes(current.concat(code))
        .then(function (cart) {
          if (!cart || !Array.isArray(cart.discount_codes)) {
            // La tienda no soporta codigos via API: se aplica al pagar.
            state.pendingCode = code;
            showDiscountMessage('', false);
            return refresh();
          }
          var applied = cart.discount_codes.filter(function (c) { return c.code.toLowerCase() === code.toLowerCase() && c.applicable; })[0];
          if (applied) {
            el.discountInput.value = '';
            showDiscountMessage('', false);
          } else {
            showDiscountMessage(config.discount.invalid, true);
            return applyCodes(current).then(refresh);
          }
          return refresh();
        })
        .catch(function () {
          state.pendingCode = code;
          return refresh();
        });
    });
  }

  drawer.addEventListener('click', function (event) {
    var target = event.target.closest('[data-cmx-action], [data-cmx-close]');
    if (!target) return;
    if (target.hasAttribute('data-cmx-close')) { hide(); return; }
    var action = target.getAttribute('data-cmx-action');
    var key = target.getAttribute('data-key');
    var line = target.closest('.cmx-item');
    var current = line ? parseInt(line.querySelector('.cmx-qty__val') ? line.querySelector('.cmx-qty__val').textContent : '1', 10) : 1;
    if (action === 'minus') changeLine(key, Math.max(0, current - 1));
    if (action === 'plus') changeLine(key, current + 1);
    if (action === 'remove') changeLine(key, 0);
    if (action === 'add') addVariant(target.getAttribute('data-variant'), target);
    if (action === 'remove-code') {
      var code = target.getAttribute('data-code');
      var rest = ((state.cart && state.cart.discount_codes) || [])
        .filter(function (c) { return c.applicable && c.code !== code; })
        .map(function (c) { return c.code; });
      applyCodes(rest).then(refresh);
    }
  });

  overlay.addEventListener('click', hide);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) hide();
  });

  /* ---------- contador del header (Section Rendering API del tema) ---------- */
  function updateBubble() {
    nativeFetch(config.routes.root + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        var html = sections && sections['cart-icon-bubble'];
        var bubble = document.getElementById('cart-icon-bubble');
        if (!html || !bubble) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (parsed) bubble.innerHTML = parsed.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- integracion con el tema ---------- */
  // 1) Clic en el icono / links al carrito
  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest('#cmx-drawer')) return;
      var link = event.target.closest('#cart-icon-bubble, a[href="' + config.routes.cart + '"], a[href="' + config.routes.cart + '/"]');
      if (!link || link.classList.contains('cmx-viewcart')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      open();
    },
    true
  );

  // 2) Despues de que el tema agrega al carrito (fetch o XHR), abrir el mini carrito
  window.fetch = function (resource, options) {
    var url = typeof resource === 'string' ? resource : resource && resource.url ? resource.url : '';
    var fromCmx = options && options.headers && (options.headers['X-CMX'] || (options.headers.get && options.headers.get('X-CMX')));
    var promise = nativeFetch(resource, options);
    if (url.indexOf('/cart/add') > -1 && !fromCmx) {
      promise.then(function (response) {
        if (response.ok) setTimeout(open, 80);
      });
    }
    return promise;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._cmxUrl = url;
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr._cmxUrl && String(xhr._cmxUrl).indexOf('/cart/add') > -1) {
      xhr.addEventListener('load', function () { if (xhr.status >= 200 && xhr.status < 300) setTimeout(open, 80); });
    }
    return xhrSend.apply(this, arguments);
  };

  // 3) El drawer nativo de Shrine (<cart-drawer>) delega en este carrito
  function takeOverThemeDrawer() {
    document.querySelectorAll('cart-drawer, cart-notification').forEach(function (themeCart) {
      if (themeCart._cmx) return;
      themeCart._cmx = true;
      themeCart.open = function () { open(); };
      themeCart.renderContents = function () { open(); };
    });
  }
  takeOverThemeDrawer();
  document.addEventListener('DOMContentLoaded', takeOverThemeDrawer);
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(takeOverThemeDrawer);
  }

  document.addEventListener('cart:refresh', function () { refresh(); });
  window.cmxCart = { open: open, close: hide, refresh: refresh };
})();
